import {
  DataTexture,
  Group,
  Mesh,
  MeshStandardMaterial,
  MeshToonMaterial,
  RedFormat,
} from "three";

export function createToonMatGradient(gradientMapSteps: number): THREE.Texture {
  const colors = new Uint8Array(gradientMapSteps + 2);

  for (let c = 0; c <= colors.length; c++) {
    colors[c] = (c / colors.length) * 256;
  }
  const gradientMap = new DataTexture(colors, colors.length, 1, RedFormat);
  gradientMap.needsUpdate = true;

  return gradientMap;
}

export const applyToonMaterial = (clone: Group): Group => {
  clone.traverse((child) => {
    if (child.type === "Mesh") {
      const castChild = child as Mesh;

      // Create a new material and copy the old one (copies all textures/settings)
      const toonMaterial = new MeshToonMaterial();
      toonMaterial.copy(castChild.material as MeshStandardMaterial);

      // Create a custom gradient map (currently hard coded to 2 steps)
      toonMaterial.gradientMap = createToonMatGradient(2);

      // Replace the old material with the new one
      castChild.material = toonMaterial;

      // Update it
      (castChild.material as MeshToonMaterial).needsUpdate = true;
    }
  });
  return clone;
};
